// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { HallMemberMenu } from './hall-member-menu'

const COMPONENT = 'hallMemberMenu'

interface Prop {
  hallId: string
  userId: string
  isAdmin: boolean
  isInAdminsPage?: boolean
}

export const showHallMemberMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT, props, preventBackClick })

export default {
  [COMPONENT]: { Component: HallMemberMenu },
}
